<!--首页-->
<template>
  <div class="height:100%">
    <van-sticky>
      <van-search
        v-model="params.keywords"
        placeholder="请输入搜索关键词"
        show-action
        shape="round"
        @keyup="onChange"
        @search="onSearch"
      >
        <div slot="action" @click="onSearch">搜索</div>
      </van-search>
      <div v-if="false" class="screeing-box" :style="screeningShow ? 'height:100%':''">
        <div class="screening-goods">
          <div class="screeing-goods-top">
            <div class="screening-1" @click="onScreeningShow(1)">
              <div>{{options1[options1_key]}}</div>
              <!-- <div wx:for="{{options1}}" wx:key="{{index}}" class="{{options1_key==index ? 'options_title':''}} options_title_box" wx:if="{{options1_show}}" catchtap="onOptions1Change" data-index="{{index}}">{{item}}</div> -->
            </div>
            <div class="screening-2" @click="onScreeningShow(2)">
              <div>{{options2[options2_key]}}</div>
              <!-- <div wx:for="{{options2}}" wx:key="{{index}}" class="{{options2_key==index ? 'options_title' :''}} options_title_box" wx:if="{{options2_show}}" catchtap="onOptions2Change" data-index="{{index}}">{{item}}</div> -->
            </div>
            <div class="screening-top-right" @click="onSideChange">
              <div>筛选</div>
              <img class="screenging-img" src="https://static.dierqudao.com/images/vfd/screening.png"/>
            </div>
          </div>
          <div class="screeing-items">
            <div
              v-for="(item,index) in options1"
              :key="index"
              v-if="options1_show"
              :class="options1_key==index ? 'options_title options_title_box':'options_title_box' "
              @click="onOptions1Change(index)"
            >{{item}}
            </div>
            <div
              v-for="(item,index) in options2"
              :key="index"
              :class="options2_key==index ? 'options_title options_title_box' :'options_title_box' "
              v-if="options2_show"
              @click="onOptions2Change(index)"
            >{{item}}
            </div>
          </div>
        </div>
      </div>
    </van-sticky>

    <div style="height:0.8rem"></div>

    <van-pull-refresh v-model="loadingFresh" @refresh="onRefresh">
      <van-list v-model="loadingMore" :finished="noMore" finished-text="没有更多了" @load="onLoad">
        <div>
          <GoodsItems :goodsList="list"></GoodsItems>
        </div>

        <!--<div v-if="noMore" class="search-tip" >
                    暂无数据
        </div>-->
      </van-list>
    </van-pull-refresh>
    <van-popup v-model="sideShow" position="right" :style="{ height: '100%',width:'80%' }" @close='onClose'>
      <div class="side-box" style="height:100%">
        <div class="price-interval">
          <div class="price-interval-title">价格区间(元)</div>
          <div class="price-interval-box">
            <van-field
              type="digit"
              v-model="params.price_range[0]"
              placeholder="最低价"
              @input="onPriceRangeChange1"
              input-align="center"
            />
            <div style="color:#999">——</div>
            <van-field
              type="digit"
              v-model="params.price_range[1]"
              placeholder="最高价"
              @input="onPriceRangeChange2"
              input-align="center"
            />
          </div>

          <div class="interval-items">
            <div
              v-for="(item,index) in price_interval"
              :class="interval_index==index ? 'interval_change' : ''"
              :key="index"
              @click="onIntervalClick(index)"
            >{{item[0]}}-{{item[1]}}
            </div>
          </div>
        </div>
        <div class="side-btn">
          <div class="side-btn-1" @click="onCancel">重置</div>
          <div class="side-btn-2" @click="onSave">确定</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<style scoped>
  .options_title {
    color: rgba(250, 74, 85, 1);
  }

  .options_title_box {
    background: #fff;
    line-height: 30px;
    /* border-bottom: 1rpx solid #999; */
  }

  .screeing-items {
    width: 6.61rem;
  }

  .screeing-goods-top {
    width: 100%;
    display: flex;
  }

  .screening-goods {
    width: 100%;
    /* background: #ccc; */
    display: flex;
    border-bottom: 1px solid #ccc;
    margin: 0 auto;
    background: #fff;
    flex-direction: column;
    align-items: center;
  }

  .screening-goods .screening-1,
  .screening-goods .screening-2 {
    width: 3.2rem;
    text-align: center;
    line-height: 0.8rem;
  }

  .screeing-box {
    width: 100%;
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    z-index: 888;
  }

  .screening-top-right {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 55px;
    font-size: 14px;
    color: #707070;
  }

  .screenging-img {
    width: 16px;
    height: 16px;
  }

  .side-box {
    height: 100%;
    width: 100%;
    background: #fff;
    position: relative;
  }

  .side-btn {
    position: fixed;
    bottom: 44px;
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .side-btn div {
    width: 40%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
  }

  .side-btn-1 {
    background: rgba(250, 74, 85, 0.8);
    border-radius: 25px 0 0 25px;
  }

  .side-btn-2 {
    background: rgba(250, 74, 85, 1);
    border-radius: 0 25px 25px 0;
  }

  .price-interval {
    margin-top: 20px;
  }

  .price-interval-title {
    color: #999;
    font-size: 14px;
    margin-left: 10px;
  }

  .price-interval-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .price-interval-box div {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .interval-items {
    display: flex;
    justify-content: space-evenly;
  }

  .interval-items div {
    width: 30%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: rgba(250, 74, 85, 0.5);
  }

  .interval-items .interval_change {
    background: rgba(250, 74, 85, 1) !important;
  }

  .van-search--show-action {
    background: #f2f2f2 !important;
  }

  .search-tip {
    padding: 0 10px;
    font-size: 14px;
    line-height: 28px;
  }

  .search-tip .search-tip-title {
    color: #999;
  }

  .search-tip .search-tip-wrap {
    display: flex;
    flex-wrap: wrap;
  }

  .search-tip .search-tip-wrap div {
    color: #666;
    display: flex;
    width: 50%;
  }
</style>

<script>
    import Vue from "vue";
    import GoodsItems from "@/components/GoodsItem1.vue";
    import {Search, PullRefresh, List, Popup, Sticky} from "vant";

    Vue.use(Popup).use(Sticky);
    export default {
        name: "GoodsList2",
        components: {
            Search,
            GoodsItems,
            [PullRefresh.name]: PullRefresh,
            [List.name]: List
        },
        data: function () {
            return {
                loadingFresh: false,
                loadingMore: false,
                noMore: true,
                screeningShow: false,
                sideShow: false,
                params: {
                    p: 1,
                    step: 5,
                    keywords: "",
                    cate_id: 0,
                    sort: [],
                    price_sort: [],
                    price_range: ["", ""]
                },
                list: [],
                homeTop: 0,
                locaKeywordsList: [],

                options1: ["默认排序", "销量升序", "销量降序"],
                options2: ["价格排序", "价格升序", "价格降序"],
                price_interval: [
                    [0, 50],
                    [50, 100],
                    [100, 500]
                ],
                options1_key: 0,
                options2_key: 0,
                options1_show: false,
                options2_show: false,
                interval_index: 999
            };
        },
        filter: {},
        activated() {
            let that = this;

            if (!this.$route.meta.isBack) {
                // 清空查询条件和数据
                that.list = [];
                that.params.p = 1;
                that.params.keywords = "";
                that.loadingMore = false;
                that.noMore = true;
                that.params.sort = [],
                    that.params.price_sort = [],
                    that.params.price_range = ["", ""]

            }

            that.interval_index = 999
            this.params.cate_id = this.$route.query.cate_id;
            this.$route.meta.isBack = false;

            document.getElementById("app").scrollTop = this.homeTop || 0;
            this.onSearch()

        },
        mounted() {
            document.title = "分类商品";
            // this.fetch();
            // this.onSearch()

        },
        destroyed() {
        },
        beforeRouteEnter(to, from, next) {
            if (from.path == "/goodsdetail" || from.path == "/shopgoodsdetail") {
                to.meta.isBack = true;
            } else {
                to.meta.isBack = false;
            }
            next();
        },
        methods: {
            onPriceRangeChange1(value) {
                let that = this;
                var s = "params.price_range[0]";
                this.params.price_range[0] = value,
                    this.interval_index = 999,
                    this.price_interval = [
                        [0, 50],
                        [50, 100],
                        [100, 500]
                    ]
                // console.log(this.data.price_interval);
            },
            onPriceRangeChange2(value) {
                let that = this;
                this.params.price_range[1] = value,
                    this.interval_index = 999,
                    this.price_interval = [
                        [0, 50],
                        [50, 100],
                        [100, 500]
                    ]
                // console.log(this.data.params);
            },
            onIntervalClick(i) {
                console.log(i)
                this.params.price_range = this.price_interval[i],
                    this.interval_index = i
            },
            onScreeningShowBack() {
                this.screeningShow = false;
                this.options2_show = false;
                this.options1_show = false;
                //   console.log('onScreeningShowBack')
            },
            onScreeningShow(i) {
                console.log(i);
                if (i == 1) {
                    this.options1_show = !this.options1_show;
                    this.options2_show = false;
                    this.screeningShow = true;
                    console.log(this.options1_show, this.options2_show, this.screeningShow);
                } else {
                    this.options2_show = !this.options2_show;
                    this.options1_show = false;
                    this.screeningShow = true;
                }
            },
            onSideChange() {
                this.sideShow = true;
                console.log(this.sideShow)
            },

            onSave() {
                this.sideShow = false,
                    this.params.p = 1
                this.fetch()
            },
            onCancel() {

                this.params.price_range = ['', '']
                this.interval_index = 999
                this.sideShow = false
                this.params.p = 1
                this.fetch()
            },
            onClose() {
                this.sideShow = false
            },
            onOptions1Change(index) {
                if (index == 0) {
                    this.params.sort = [];
                } else if (index == 1) {
                    this.params.sort = ["asc"];
                } else {
                    this.params.sort = ["desc"];
                }
                this.options1_show = false;
                this.options1_key = index;
                this.screeningShow = false;
                this.params.p = 1;
                this.fetch();
            },
            onOptions2Change(index) {
                //   let s = "params.price_sort";
                //   wx.pageScrollTo({
                //     scrollTop: 0
                //   });
                if (index == 0) {
                    this.params.price_sort = [];
                } else if (index == 1) {
                    this.params.price_sort = ["asc"];
                } else {
                    this.params.price_sort = ["desc"];
                }
                this.options2_key = index;
                this.options2_show = false;
                this.screeningShow = false;

                this.params.p = 1;
                this.fetch();
            },

            fetch() {
                let that = this;
                that.loadingMore = true;
                that.params.cate_id = this.$route.query.cate_id
                console.log(that.params);
                this.$api.get("/api/goods/goodsList2", that.params, res => {
                    that.loadingMore = false;
                    console.log(res.data.currentpage)
                    if (res.data.currentpage == 1) {
                        that.list = res.data.list;
                        that.loadingFresh = false;
                        // console.log(that.list)
                    } else {
                        let list = that.list.concat(res.data.list);
                        that.list = list;
                    }
                    if (res.data.list.length == 0) {
                        that.noMore = true;
                    }

                    this.params.p += 1;
                });
            },

            getFetchCommon() {
                let that = this;
                that.params.p = 1;
                that.list = [];
                that.noMore = false;

                that.fetch();

            },

            onChange() {
                let that = this;
                if (!this.params.keywords) {
                    that.noMore = true;
                }
                that.getFetchCommon();
            },

            onSearch() {
                let that = this;
                that.getFetchCommon();
            },

            onSelect(keyword) {
                let that = this;
                that.params.keywords = keyword;
                that.getFetchCommon();
            },

            onLoad() {
                console.log(111)
                if (this.params.p > 1) {
                    setTimeout(() => {
                        this.fetch();
                    }, 500);
                }
            },

            onRefresh() {
                let that = this;
                that.params.p = 1;
                // that.noMore = false;
                // if (!that.params.keywords) {
                //     that.noMore = true;
                // }
                that.fetch();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// GoodsList2.vue?f832af8c